/**
 * For common strings used across the projects
 */

// hex opacity for menu backgrounds
export const BACKGROUND_HEX_OPACITY = "DD";
